import * as React from "react";
import type { SVGProps } from "react";
const SvgQuoraIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.146 18.127h-1.373c-.07.632-.492 1.443-1.547 1.443-.961 0-1.655-.665-2.32-1.678 2.071-1.603 3.501-4.101 3.501-7.172.005-5.508-4.528-9.22-9.3-9.22-4.673 0-9.267 3.736-9.267 9.22 0 6.286 6.155 10.388 11.672 8.86.923 1.575 2.142 2.92 4.462 2.92 3.835 0 4.256-3.53 4.172-4.373ZM15.42 15.43c-.914-1.368-2.048-2.447-4.289-2.447-1.43 0-2.545.47-3.234 1.07l.572 1.138c.29-.14.61-.187.928-.187 1.664 0 2.517 1.443 3.244 2.873-.469.14-.97.197-1.533.197-3.516 0-5.039-2.484-5.039-7.345 0-4.894 1.523-7.402 5.039-7.402 3.572 0 5.095 2.508 5.095 7.392.005 1.96-.253 3.544-.783 4.711Z"
    />
  </svg>
);
export default SvgQuoraIcon;
